import { Identifier, randomUUID } from "../core";
export class PCustomParameterInstanceId extends Identifier {
    constructor() {
        super("PCustomParameterInstanceId", randomUUID());
    }
}
